var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExistingCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 148,
    viewBox: "0 0 160 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1866_5309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.8115 84.1235C88.9239 84.1235 107.66 65.4037 107.66 42.3118C107.66 19.2198 88.9239 0.5 65.8115 0.5C42.6991 0.5 23.9628 19.2198 23.9628 42.3118C23.9628 65.4037 42.6991 84.1235 65.8115 84.1235Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.392 157.213V163.974C129.392 166.473 127.471 168.5 125.11 168.5H4.78177C2.41313 168.5 0.5 166.473 0.5 163.974V110.189C0.5 98.5958 9.37826 89.2041 20.3353 89.2041H53.9352C54.3493 89.2041 54.722 89.4606 54.8959 89.8661L64.5526 110.429C64.7183 110.768 65.1738 110.768 65.3311 110.429L74.9962 89.8661C75.1618 89.4606 75.5428 89.2041 75.9569 89.2041H98.1857C94.5168 95.8569 92.4214 103.511 92.4214 111.653C92.4214 134.069 108.273 152.778 129.392 157.213Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.875 152.894C161.791 152.894 180.359 134.342 180.359 111.455C180.359 88.5587 161.791 70.007 138.875 70.007C124.249 70.007 111.387 77.57 104.008 89.0055C99.8256 95.468 97.399 103.18 97.399 111.455C97.399 131.032 110.981 147.441 129.251 151.769C132.341 152.505 135.562 152.894 138.875 152.894ZM139.223 87.3837C142.779 87.3837 145.657 90.2593 145.657 93.8125V104.538H156.392C159.948 104.538 162.826 107.413 162.826 110.966C162.826 114.52 159.948 117.395 156.392 117.395H145.657V128.12C145.657 131.674 142.779 134.549 139.223 134.549C135.666 134.549 132.788 131.674 132.788 128.12V117.395H122.054C118.497 117.395 115.619 114.52 115.619 110.966C115.619 107.413 118.497 104.538 122.054 104.538H132.788V93.8125C132.788 90.2593 135.666 87.3837 139.223 87.3837Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1866_5309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 168,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExistingCustomer);
export default __webpack_public_path__ + "static/media/ExistingCustomer.9e7e2ccc508dc8c3feace26f6ccba3aa.svg";
export { ForwardRef as ReactComponent };